module.exports = __webpack_public_path__ + "static/media/onboarding-feedback.59730795.png";